import { jsxs as pr, jsx as m, Fragment as Rr } from "react/jsx-runtime";
import { DotsIcon as Hr } from "@systemeio/ui/icons";
import { Popover as Wr } from "@systemeio/ui";
import xr, { useRef as k, useState as zr, useTransition as Mr, useMemo as I, useEffect as Nr, Fragment as Ar } from "react";
import { twMerge as yr, twJoin as wr } from "tailwind-merge";
import { EditorExtensionEnum as o } from "../enums/editor-extensions-enum.mjs";
import { getExistingExtensions as Pr } from "../utils/get-extensions.mjs";
import { renderInSemanticOrder as S } from "./render-semantic-order.mjs";
import { semanticOrder as kr } from "./toolbar-semantic-order.mjs";
import { useImageExtensionToolbar as Ur } from "../extensions/image-extension/use-image-extension-toolbar.mjs";
import { useHistoryExtensionToolbar as $r } from "../extensions/history-extension/use-history-extension-toolbar.mjs";
import { useIndentExtensionToolbar as Vr } from "../extensions/indent-extension/use-indent-extension-toolbar.mjs";
import { useLinkExtensionToolbar as jr } from "../extensions/link-extension/use-link-extension-toolbar.mjs";
import { useTextAlignExtensionToolbar as _r } from "../extensions/text-align-extension/use-text-align-extension-toolbar.mjs";
import { useHeadingExtensionToolbar as qr } from "../extensions/heading-extension/use-heading-extension-toolbar.mjs";
import { useSubstitutesExtensionToolbar as Dr } from "../extensions/substitutes-extension/use-substitutes-extension-toolbar.mjs";
import { useTextFormatExtensionToolbar as g } from "../extensions/text-format-extension/use-text-format-extension-toolbar.mjs";
import { TextFormatEnum as p } from "../extensions/text-format-extension/text-format-enum.mjs";
import { useFontSizeExtensionToolbar as Jr } from "../extensions/font-size-extension/use-font-size-extension-toolbar.mjs";
import { useListExtensionToolbar as Ir } from "../extensions/list-extension/use-list-extension-toolbar.mjs";
import { ListEnum as Sr } from "../extensions/list-extension/list-enum.mjs";
import { useFontFamilyExtensionToolbar as Kr } from "../extensions/font-family-extension/use-font-family-extension-toolbar.mjs";
import { useTextColorExtensionToolbar as Gr } from "../extensions/text-color-extension/use-text-color-extension-toolbar.mjs";
import { useTextBackgroundColorExtensionToolbar as Qr } from "../extensions/text-background-color-extension/use-text-background-color-extension-toolbar.mjs";
import { useSpecialCharactersExtensionToolbar as Xr } from "../extensions/special-characters-extension/use-special-characters-extension-toolbar.mjs";
import { useParagraphSpaceExtensionToolbar as Yr } from "../extensions/paragraph-extension/use-paragraph-space-extension.mjs";
import { useLineHeightExtensionToolbar as Zr } from "../extensions/line-height-extension/use-line-height-extension-toolbar.mjs";
const Lo = ({
  extensions: vr,
  editor: t,
  toolbarStyles: Fr,
  toolbarClassName: Lr,
  showAllItems: h = !1,
  extensionOptions: e
}) => {
  const {
    hasHistory: v,
    hasHeading: F,
    hasIndent: L,
    hasTextAlign: C,
    hasLink: B,
    hasTextColor: R,
    hasFontSize: H,
    hasTextBackgroundColor: W,
    hasFontFamily: z,
    hasSubstitution: M,
    hasSpecialCharacters: N,
    hasImage: A,
    hasOrderedList: w,
    hasBulletList: P,
    hasListItem: x,
    hasBold: U,
    hasItalic: $,
    hasUnderline: V,
    hasStrike: j,
    hasParagraph: _,
    hasSimpleHardBreak: q,
    hasLineHeight: D
  } = Pr(vr), u = k(null), J = k(null), [T, K] = zr([]), [, G] = Mr(), E = k([]), Q = Ur(
    t,
    e == null ? void 0 : e[o.Image]
  ), X = $r(t), Y = Vr(t), Z = jr(
    t,
    e == null ? void 0 : e[o.Link]
  ), O = _r(t), rr = qr(t), or = Dr(
    t,
    e == null ? void 0 : e[o.Substitution]
  ), er = g(t, p.Bold), tr = g(t, p.Italic), ar = g(t, p.Underline), ir = g(t, p.Strike), sr = Jr(
    t,
    e == null ? void 0 : e[o.FontSize]
  ), nr = Ir(t, Sr.OrderedList), lr = Ir(t, Sr.BulletList), cr = Kr(
    t,
    e == null ? void 0 : e[o.FontFamily]
  ), fr = Gr(
    t,
    e == null ? void 0 : e[o.TextColor]
  ), mr = Qr(
    t,
    e == null ? void 0 : e[o.TextBackgroundColor]
  ), ur = Xr(t), dr = Yr(t), br = Zr(t), i = I(() => {
    const a = [], r = (s, n) => {
      Array.isArray(s) ? s.forEach((l, d) => {
        a.push({
          id: `${n}-${d}`,
          toolbarItem: l,
          ref: xr.createRef(),
          key: n
        });
      }) : a.push({
        id: n,
        toolbarItem: s,
        ref: xr.createRef(),
        key: n
      });
    };
    return _ && !q && r(dr, o.Paragraph), D && r(br, o.LineHeight), v && r(X, o.History), A && r(Q, o.Image), B && r(Z, o.Link), L && r(Y, o.Indent), C && r(O, o.TextAlign), F && r(rr, o.Heading), M && r(or, o.Substitution), U && r(er, o.Bold), $ && r(tr, o.Italic), V && r(ar, o.Underline), j && r(ir, o.Strike), H && r(sr, o.FontSize), w && x && r(nr, o.OrderedList), P && x && r(lr, o.BulletList), z && r(cr, o.FontFamily), R && r(fr, o.TextColor), W && r(mr, o.TextBackgroundColor), N && r(ur, o.SpecialCharacters), a;
  }, [
    _,
    q,
    dr,
    D,
    br,
    v,
    X,
    A,
    Q,
    B,
    Z,
    L,
    Y,
    C,
    O,
    F,
    rr,
    M,
    or,
    U,
    er,
    $,
    tr,
    V,
    ar,
    j,
    ir,
    H,
    sr,
    w,
    x,
    nr,
    P,
    lr,
    z,
    cr,
    R,
    fr,
    W,
    mr,
    N,
    ur
  ]), hr = (a, r) => a.length === r.length && a.every((s, n) => s === r[n]);
  Nr(() => {
    const a = () => {
      var Er;
      if (!u.current) return;
      if (h) {
        const c = i.map((f) => f.id);
        hr(E.current, c) || (E.current = c, G(() => K(c)));
        return;
      }
      const s = u.current.clientWidth, n = [...i].sort(
        (c, f) => kr.flatMap((b) => b).indexOf(c.key) - kr.flatMap((b) => b).indexOf(f.key)
      ), l = [];
      let d = 0, y = !1;
      const Br = ((Er = J.current) == null ? void 0 : Er.offsetWidth) ?? 0;
      for (const c of n) {
        const f = c.ref.current;
        if (!f) continue;
        const b = f.offsetWidth, gr = d + b;
        !y && gr <= s ? (l.push(c.id), d = gr) : y = !0;
      }
      y && l.length > 0 && d + Br > s && l.pop(), hr(E.current, l) || (E.current = l, G(() => K(l)));
    }, r = new ResizeObserver(a);
    return u.current && r.observe(u.current), a(), () => {
      r.disconnect();
    };
  }, [i, h]);
  const Cr = I(
    () => i.filter((a) => T.includes(a.id)),
    [i, T]
  ), Tr = I(
    () => i.filter((a) => !T.includes(a.id)),
    [i, T]
  );
  return /* @__PURE__ */ pr(
    "div",
    {
      style: Fr,
      className: yr(
        "border-text-secondary/30 z-sticky bg-background-secondary sticky top-0 flex items-center rounded-t-lg border border-b-0 p-1",
        Lr
      ),
      children: [
        /* @__PURE__ */ pr(
          "div",
          {
            ref: u,
            className: yr("flex w-full", h && "flex-wrap gap-1"),
            children: [
              S({ source: Cr, skipRef: !0 }),
              /* @__PURE__ */ m(
                "div",
                {
                  ref: J,
                  className: wr(
                    "ml-auto flex items-center",
                    Tr.length > 0 ? "visible" : "invisible",
                    h && "hidden"
                  ),
                  children: /* @__PURE__ */ m(
                    Wr,
                    {
                      anchor: "bottom end",
                      className: "main-transition-colors data-[open]:bg-brand-primary/10 group h-7 rounded-lg px-2",
                      label: /* @__PURE__ */ m(Rr, { children: S({
                        source: Tr,
                        skipRef: !0,
                        skipBorder: !0,
                        inTooltip: !0
                      }) }),
                      children: /* @__PURE__ */ m(Hr, { className: "group-hover:fill-brand-primary main-transition-colors" })
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "pointer-events-none absolute left-0 top-0 flex h-0 overflow-hidden opacity-0", children: S({ source: i }) }),
        i.filter(({ toolbarItem: a }) => a.additionalRender).map(({ toolbarItem: a, id: r }) => /* @__PURE__ */ m(Ar, { children: a.additionalRender }, `${r}-additional-render`))
      ]
    }
  );
};
export {
  Lo as Toolbar
};
